import React from "react";
import { CheckIcon, GiftIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { bonuses } from "../../data/bonuses";
export function Bonuses() {
  return <section className="bg-sand px-4 py-16 sm:py-24" data-id="element-141" data-mp="1ckwngh3iixq5">
      <div className="mx-auto max-w-4xl" data-id="element-142" data-mp="1clpiikt3zysg">
        <div className="flex justify-center" data-id="element-143" data-mp="18jul3reau5jy">
          <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-alert text-white" data-id="element-144" data-mp="18kw026yfrc6y">
            <GiftIcon className="h-7 w-7" aria-hidden="true" data-id="element-145" data-mp="259bou0tq1hj0" />
          </span>
        </div>
        <h2 className="text-balance mt-4 text-center font-serif text-3xl font-bold leading-tight text-ink sm:text-5xl" data-id="element-146" data-mp="20c1z0k2f73un">
          Get these <em className="text-alert" data-id="element-147" data-mp="1wb00k5gbuvtq">5 bonuses FREE</em> with your purchase
        </h2>
        <p className="mt-3 text-center text-[17px] text-ink/70" data-id="element-148" data-mp="1r9sp9wez7eib">
          A combined value of <strong className="text-ink" data-id="element-149" data-mp="kvl2szganzxk">$197</strong> — included today at no extra cost.
        </p>

        <div className="-mx-4 mt-10 space-y-8 sm:mx-0" data-id="element-150" data-mp="ftca847c2zvz">
          {bonuses.map(b => <article key={b.number} className="overflow-hidden bg-white sm:rounded-3xl sm:shadow-[0_8px_30px_rgba(20,26,43,0.08)]" data-id="element-151" data-mp="1euye85rhafcu">
              <div className="relative" data-id="element-152" data-mp="1jqdravhnw787">
                <img src={b.image} alt={`Bonus #${b.number}: ${b.title}`} className="block w-full" loading="lazy" data-id="element-153" data-mp="15trttllpkkeb" />
                <span className="absolute left-4 top-4 rounded-full bg-alert px-3 py-1 text-xs font-extrabold uppercase tracking-wider text-white" data-id="element-154" data-mp="1aqqoc59aatd1">
                  Bonus #{b.number}
                </span>
              </div>
              <div className="px-5 py-6 sm:px-8 sm:py-8" data-id="element-155" data-mp="10v6x3w5o0ium">
                <div className="flex flex-wrap items-center gap-x-3 gap-y-1" data-id="element-156" data-mp="n3a8i237gr2z">
                  <span className="text-[15px] font-semibold text-ink/50 line-through" data-id="element-157" data-mp="r3sx7n9sxh0y">Value: ${b.value}</span>
                  <span className="rounded-md bg-cta/10 px-2 py-0.5 text-sm font-extrabold uppercase text-cta" data-id="element-158" data-mp="d41exac95eh5">
                    Free today
                  </span>
                </div>
                <h3 className="mt-2 font-serif text-2xl font-bold leading-snug text-navy sm:text-3xl" data-id="element-159" data-mp="2jt3fa3f44dyj">{b.title}</h3>
                <p className="mt-3 text-[16px] leading-relaxed text-ink/75" data-id="element-160" data-mp="2f1lb76hslx9c">{b.description}</p>

                {b.flow && <div className="mt-4 flex flex-wrap items-center gap-x-1.5 gap-y-2" data-id="element-161" data-mp="2b0ro2fc6cmhi">
                    {b.flow.map((f, i) => <React.Fragment key={f} data-id="element-162" data-mp="32rfplshrftvp" data-mpi={i}>
                        <span className="rounded-lg bg-navy px-3 py-1.5 text-sm font-bold text-white" data-id="element-163" data-mp="32qea9btpol86">{f}</span>
                        {i < b.flow!.length - 1 && <span className="font-bold text-gold" aria-hidden="true" data-id="element-164" data-mp="2ynq6vjnro6il">→</span>}
                      </React.Fragment>)}
                  </div>}

                {b.list && <>
                    <p className="mt-4 text-sm font-bold uppercase tracking-wide text-ink" data-id="element-165" data-mp="1ibuj1dwz4m6p">{b.listLabel}</p>
                    <ul className="mt-2 space-y-1.5" data-id="element-166" data-mp="1dbg8np7wh05i">
                      {b.list.map(item => <li key={item} className="flex items-start gap-2.5 text-[16px] text-ink/85" data-id="element-167" data-mp="139m5f9w64oqs">
                          <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-168" data-mp="188fhqyzpy9pd" />
                          <span data-id="element-169" data-mp="1d55tja4hqj4z">{item}</span>
                        </li>)}
                    </ul>
                  </>}

                {b.closing.map(c => <p key={c} className="mt-5 font-serif text-lg font-semibold italic leading-snug text-gold" data-id="element-170" data-mp="1lysoiy0vjid4">
                    {c}
                  </p>)}
              </div>
            </article>)}
        </div>

        <div className="mt-12" data-id="element-171" data-mp="20w1kk514hab6">
          <CTAButton label="I want all 5 bonuses" data-id="element-172" data-mp="20va09qcz6z07" />
        </div>
      </div>
    </section>;
}